import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useLocation } from "wouter";
import { 
  BarChart3,
  Shield,
  ArrowRight,
  Target,
  TrendingUp,
  Brain
} from "lucide-react";

export default function PremiumWelcomePage() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen bg-[#111213] relative">
      {/* Subtle dot grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" 
           style={{
             backgroundImage: `radial-gradient(circle, #C28B4A 1px, transparent 1px)`,
             backgroundSize: '24px 24px'
           }}>
      </div>

      <div className="relative z-10 container mx-auto px-6 py-32 max-w-7xl">
        
        {/* Strategic Header */}
        <div className="text-center mb-24">
          <div className="flex items-center justify-center mb-8">
            <img 
              src="/veritus-icon.png" 
              alt="Veritus" 
              className="w-16 h-16 mr-4"
            />
            <span className="text-[#C28B4A] font-medium text-lg tracking-wide">
              STRATEGIC INTELLIGENCE ADVISOR
            </span>
          </div>

          <h1 className="text-7xl md:text-8xl font-semibold mb-6 leading-tight text-[#E6E7E8]">
            VERITUS
          </h1>

          <p className="text-2xl text-[#B5B7BB] max-w-4xl mx-auto leading-relaxed font-normal mb-16">
            Executive Decision-Making Intelligence
            <br />
            <span className="text-[#E6E7E8]">Intelligence With Purpose</span>
          </p>

          <div className="flex justify-center">
            <button
              onClick={() => setLocation("/login")}
              className="bg-[#C28B4A] hover:opacity-90 text-[#111213] font-semibold text-lg px-8 py-3 rounded-sm transition-opacity"
            >
              Enter Platform
              <ArrowRight className="w-5 h-5 ml-2 inline" />
            </button>
          </div>
        </div>

        {/* Core Capabilities */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="bg-[#151617] border border-[#2B2D2E] rounded-sm p-6">
            <div className="w-12 h-12 bg-[#2B2D2E] rounded-sm flex items-center justify-center mb-6">
              <BarChart3 className="w-6 h-6 text-[#C28B4A]" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-[#E6E7E8]">Strategic Analysis</h3>
            <p className="text-[#B5B7BB] leading-relaxed">
              Comprehensive intelligence synthesis for complex, high-impact decisions with actionable insights.
            </p>
          </div>

          <div className="bg-[#151617] border border-[#2B2D2E] rounded-sm p-6">
            <div className="w-12 h-12 bg-[#2B2D2E] rounded-sm flex items-center justify-center mb-6">
              <Target className="w-6 h-6 text-[#C28B4A]" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-[#E6E7E8]">Decision Validation</h3>
            <p className="text-[#B5B7BB] leading-relaxed">
              Executive advisory services with 48-hour delivery for strategic reports and ongoing consultation.
            </p>
          </div>

          <div className="bg-[#151617] border border-[#2B2D2E] rounded-sm p-6">
            <div className="w-12 h-12 bg-[#2B2D2E] rounded-sm flex items-center justify-center mb-6">
              <Shield className="w-6 h-6 text-[#C28B4A]" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-[#E6E7E8]">Intelligence Synthesis</h3>
            <p className="text-[#B5B7BB] leading-relaxed">
              SOC 2 Type II compliance with institutional-grade security for enterprise intelligence operations.
            </p>
          </div>
        </div>

        {/* Service Tiers */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#C28B4A] mb-2">Strategic Reports</div>
            <div className="text-[#B5B7BB] text-lg">Ad-hoc Analysis</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#C28B4A] mb-2">Executive Advisory</div>
            <div className="text-[#B5B7BB] text-lg">Ongoing Consultation</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#C28B4A] mb-2">Enterprise Intelligence</div>
            <div className="text-[#B5B7BB] text-lg">Institutional Partnership</div>
          </div>
        </div>

        {/* Strategic CTA Section */}
        <div className="bg-[#151617] border border-[#2B2D2E] rounded-sm p-12 text-center">
          <h2 className="text-4xl font-semibold mb-6 text-[#E6E7E8]">
            Transform Uncertainty Into Confident Action
          </h2>
          <p className="text-xl text-[#B5B7BB] mb-10 max-w-3xl mx-auto leading-relaxed">
            Strategic foresight and precision for C-suite leaders making complex, high-impact decisions.
          </p>
          <div className="flex justify-center">
            <button
              onClick={() => setLocation("/login")}
              className="bg-[#C28B4A] hover:opacity-90 text-[#111213] font-semibold text-xl px-12 py-4 rounded-sm transition-opacity"
            >
              Access Platform
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-16">
          <div className="h-px bg-[#2B2D2E] w-64 mx-auto mb-4"></div>
          <p className="text-[#B5B7BB]">© 2025 AcronIQ Veritus Intelligence. Strategic Intelligence Advisor.</p>
        </div>
      </div>
    </div>
  );
}
